/* 布局 */
//前台
import Layout from "@views/layout";

const topicarticleansRouter = {
    path: "/business",
    component: Layout,
    redirect: {
        name: "BUSINESS"
    },
    children: [
            {
            path: "topicarticleans",
            name: "TOPICARTICLEANS",
            meta: {
                title: "话题文章回复管理",
                sort: 1,
            },
            component: () => import("@views/business/topicarticleans/index.vue"),
            redirect: {
                name: "TOPICARTICLEANS_LIST",
            },
            children: [
                {
                    path: "list",
                    name: "TOPICARTICLEANS_LIST",
                    meta: {
                        title: "话题文章回复管理",
                        sort: 2,
                        keepAlive:true
                    },
                    component: () => import("@views/business/topicarticleans/list.vue"),
                },
                                {
                    path: "add",
                    name: "TOPICARTICLEANS_ADD",
                    meta: {
                        title: "新增话题文章回复表",
                        parentPath: '/business/topicarticleans/list',
                        operate: true,
                    },
                    component: () => import("@views/business/topicarticleans/form.vue"),
                },
                                                {
                    path: "edit",
                    name: "TOPICARTICLEANS_EDIT",
                    meta: {
                        title: "编辑话题文章回复表",
                        parentPath: '/business/topicarticleans/list',
                        operate: true,
                    },
                    component: () => import("@views/business/topicarticleans/form.vue"),
                },
                                        ],
    },


        ],
};

export default topicarticleansRouter;
